import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type { SubmenuDefinition, SubmenuCarmiProps } from '../types';
import { hasDetachedStyleProperties } from '../../Menu/editor/DetachStyles/utils';
import { withSiteDirection } from '@wix/editor-elements-common-utils';

export const props = withCompInfo<{}, SubmenuDefinition, SubmenuCarmiProps>()(
  [],
  (_, carmiData) => carmiData,
);

export const css = withCompInfo<{}, SubmenuDefinition, SubmenuCarmiProps>()(
  ['compData', 'styleProperties'],
  ({ compData, styleProperties }) => {
    const { direction, itemDirection, subItemDirection } = compData;
    const isDetached = hasDetachedStyleProperties(styleProperties);

    return {
      height: 'auto',
      '--submenu-direction': isDetached
        ? withSiteDirection(direction)
        : 'initial',
      '--submenu-item-direction': isDetached ? itemDirection : 'initial',
      '--submenu-sub-item-direction': isDetached ? subItemDirection : 'initial',
    };
  },
);

export default createComponentMapperModel({ props, css });
